// ScatterDemogsChart.jsx
import  {useState} from "react";
import {
  ScatterChart,
  Scatter,
  XAxis,
  YAxis,
  ZAxis,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Label
} from "recharts";

// colour palette for groups (match your legend colours)
const GROUP_COLOURS = {
  Age: "#1f77b4",
  Education: "#ff7f0e",
  Gender: "#d62728",
  Ethnicity: "#2ca02c",
  Electorate: "#c7c7c7",
};
// matcher because named the columns stupidly
const party_name_lookup = {
  coalition:"coalition",
  act_pred_n:"act",
  nat_pred_n:"nat",
  nzf_pred_n:"nzf",
  lab_pred_n:"lab",
  green_pred_n:"green",
 tpm_pred_n:"tpm",

};

// helper to map type_code → group (adjust as needed)
function getGroup(type_code) {
  if (["Age"].includes(type_code)) return "Age";
  if (["Education"].includes(type_code)) return "Education";
  if (["Gender"].includes(type_code)) return "Gender";
  if (["Ethnicity"].includes(type_code)) return "Ethnicity";
  if (["Electorate"].includes(type_code)) return "Electorate";
  if (["Vote 2023"].includes(type_code)) return "Vote 2023";
  return null;
}

export default function ScatterDemogsChart({ scatterDemogsRows, selectedParty }) {
  const [hovered, setHovered] = useState(null);
if(!scatterDemogsRows||!selectedParty){return}


  const fixed_selectedParty = party_name_lookup[selectedParty] 
  // build data array for current party
  const data = scatterDemogsRows
  .filter((row) => row.type !== "Vote 2023") 
  .map((row) => ({
    x: row[`${fixed_selectedParty.toLowerCase()}_2023`] * 100,      // 2023 share (%)
    y: row[`${fixed_selectedParty.toLowerCase()}_vi`] * 100,      // predicted share (%)
    name: row.type_name,
    group: getGroup(row.type),
    changelabel: Math.abs(
      (row[`${fixed_selectedParty.toLowerCase()}_vi`]* 100 || 0) -
      (row[`${fixed_selectedParty.toLowerCase()}_2023`]* 100 || 0)
    ), 
    size: Math.abs(
      (row[`${fixed_selectedParty.toLowerCase()}_vi`] || 0) -
      (row[`${fixed_selectedParty.toLowerCase()}_2023`] || 0)
    )/100, // scale to make visible
  }));
  return  (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center", // centre horizontally
        alignItems: "center",     // centre vertically
        position: "relative",   // ⬅️ important so tooltip can absolutely position
      }}
    >
    <ResponsiveContainer width="100%" height={500}>
      <ScatterChart
        margin={{ top: 20, right: 20, bottom: 20, left: 20 }}
  onMouseLeave={() => setHovered(null)}   // ⬅️ clear tooltip when leaving chart
      >
        <CartesianGrid />
        <XAxis
          type="number"
          dataKey="x"
          name="2023 Vote Share"
          unit="%"
                  domain={[
                    (dataMin) => dataMin * 0.9,   // 10% below min
                    (dataMax) => dataMax * 1.1,   // 10% above max
                ]}
        tickFormatter={(val) => val.toFixed(0) } // ⬅️ format decimals
        >
         <Label value="2023 Vote Share" position="insideBottom" offset={-5} />

        </XAxis>
        <YAxis
          type="number"
          dataKey="y"
          name="Predicted Vote Share"
          unit="%"
          domain={[
                    (dataMin) => dataMin * 0.9,   // 10% below min
                    (dataMax) => dataMax * 1.1,   // 10% above max
                ]}
        tickFormatter={(val) => val.toFixed(0) } // ⬅️ format decimals
        >
        <Label
            value="Predicted Vote Share"
            angle={-90}
            position="insideLeft"
            style={{ textAnchor: "middle" }}
        />
          </YAxis>   
           {/* ⬅️ Define the Z axis for point size */}
            <ZAxis
                type="number"
                dataKey="size"
                range={[30, 100]}   // min and max radius in pixels
                name="Change"
            />
        <Legend
            verticalAlign="bottom" 
            align="center"       
            wrapperStyle={{ paddingTop: 20  }} />

        {Object.keys(GROUP_COLOURS).map((group) => (
        <Scatter
            key={group}
            name={group}
            data={data.filter((d) => d.group === group)}
            fill={GROUP_COLOURS[group]}
            line={false}
            shape="circle"
            dataKey="x"   // ⬅️ Recharts handles y + size via YAxis + ZAxis
            onMouseEnter={(e) => setHovered(e)}   // capture hovered point
            onMouseLeave={() => setHovered(null)} // clear on exit
        />
        ))}
      </ScatterChart>
    </ResponsiveContainer>
          {/* ⬇️ Custom tooltip lives HERE, inside the wrapper <div> */}
      {hovered && (
        <div
          style={{
            position: "absolute",
            left: hovered.cx + 20, // offset from point
            top: hovered.cy,
            background: "white",
            padding: "8px",
            border: "1px solid #ccc",
            pointerEvents: "none", // don't block mouse
          }}
        >
          <strong>{hovered.payload.name}</strong> {hovered.payload.group}
          <div>2023 Vote Share: {hovered.payload.x.toFixed(1)}%</div>
          <div>Predicted: {hovered.payload.y.toFixed(1)}%</div>
          <div>Change: {hovered.payload.changelabel.toFixed(1)}%</div>
        </div>
      )}
    </div>
  );
}
